// import Order from './components/Order.vue';
import Wizard from './components/Wizard.vue';
// import Address from './components/Checkout/Address.vue';
import Confirmation from './components/Checkout/Confirmation.vue';
import ErrorView from './components/Checkout/Error.vue';
// import OrderSummary from './components/Checkout/OrderSummary.vue';

const routes = [
    {
        path: '/',
        component: Wizard,
    },
    /* {
        path: '/address',
        component: Address,
    },
    {
        path: '/summary',
        component: OrderSummary,
    }, */
    {
        path: '/confirmation',
        component: Confirmation,
    },
    {
        path: '/error',
        component: ErrorView,
    },
    {
        path: '*',
        redirect: '/',
    },
];


export default routes;



// WEBPACK FOOTER //
// ./static/js/Order/routes.js